module.exports = __webpack_public_path__ + "static/media/30OIOS8.90b7f9a9.jpg";